import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./json-editor.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./json-editor.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewChild } from "@angular/core";
import { AppControllerService } from "../../../app-controller.service";
let JsonEditorComponent = class JsonEditorComponent {
    appController;
    changeDetection;
    mySchema;
    loaded = false;
    set schema(value) {
        this.mySchema = value;
        this.updateSchema();
    }
    metadata;
    isSuperAdmin = true;
    uploadedFiles;
    jsonEditor = null;
    editor_holder;
    constructor(appController, changeDetection) {
        this.appController = appController;
        this.changeDetection = changeDetection;
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        this.loaded = true;
        this.updateSchema();
    }
    updateSchema() {
        if (this.loaded === false) {
            return;
        }
        if (this.jsonEditor !== null) {
            this.jsonEditor.destroy();
        }
        const options = {
            schema: this.mySchema,
            theme: "bootstrap4",
            iconlib: "fontawesome4"
        };
        // @ts-ignore
        this.jsonEditor = new JSONEditor(this.editor_holder.nativeElement, options, null);
        this.changeDetection.detectChanges();
        this.jsonEditor.on("ready", () => {
            // Now the api methods will be available
            if (this.metadata) {
                try {
                    this.jsonEditor.setValue(JSON.parse(this.metadata));
                    this.changeDetection.detectChanges();
                }
                catch (e) {
                    this.appController.showConsoleMessage(e);
                }
            }
            // this.jsonEditor.validate();
            this.checkUserEditingRights();
            this.changeDetection.markForCheck();
        });
        const div = this.editor_holder.nativeElement;
        const selects = div.getElementsByTagName("select");
        for (let index = 0; index <= selects.length; index++) {
            if (selects.item(index)) {
                selects.item(index).classList.remove("form-control");
                selects.item(index).classList.add("form-select");
            }
        }
    }
    evaluateMetadata() {
        if (this.getValidateErrors.length > 0) {
            return false;
        }
        else {
            return true;
        }
    }
    getValidateErrors() {
        const errors = this.jsonEditor.validate();
        return errors;
        // if (errors.length) {
        //   // errors is an array of objects, each with a `path`, `property`, and `message` parameter
        //   // `property` is the schema keyword that triggered the validation error (e.g. "minLength")
        //   // `path` is a dot separated path into the JSON object (e.g. "root.path.to.field")
        // }
        // else {
        //   // It's valid!
        // }
    }
    getMetadata() {
        return JSON.stringify(this.jsonEditor.getValue());
    }
    checkUserEditingRights() {
        if (!this.isSuperAdmin) {
            this.jsonEditor.disable();
        }
    }
    static ctorParameters = () => [
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        schema: [{ type: Input }],
        metadata: [{ type: Input }],
        isSuperAdmin: [{ type: Input }],
        editor_holder: [{ type: ViewChild, args: ["editor_holder", { static: true },] }]
    };
};
JsonEditorComponent = __decorate([
    Component({
        selector: "app-json-editor",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], JsonEditorComponent);
export { JsonEditorComponent };
